import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['']


    createslugname(event) {
        var slug = event.target.value
        if (slug.length > 1) {
            fetch("/setup/new_slug?name=" + slug, {
                method: "GET",
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(res => res.json())
                .then(resp => document.getElementById('org-slug').value = resp['name'])
        }
    }

    isvalidslug(event) {
        var slug = event.target.value
        if (slug.length > 1) {
            fetch("/setup/verify_slug?slug=" + slug, {
                method: "GET",
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(res => res.json())
                .then(resp => this.validslug(resp))
        }
    }

    validslug(data) {
        if (data['slug'] == true) {
            document.getElementById('org-valid-slug').classList.remove("hidden")
            document.getElementById('org-invalid-slug').classList.add("hidden")
        } else {
            document.getElementById('org-invalid-slug').classList.remove("hidden")
            document.getElementById('org-valid-slug').classList.add("hidden")
        }
    }

}
